import { SearchAccountMovementsRequest } from 'core/models/SearchAccountMovementsRequest';
import { useCoreService } from 'core/services/useCoreService';
import { createContext, useEffect, useMemo } from 'react';
import { AccountAuthorizations } from '../models/AccountAuthorizations';
import { useDataFetcher } from 'shared/http';
import { LoadingSpinner } from 'shared/spinner/components/LoadingSpinner';
import { useNavigate, useParams } from 'react-router-dom';
import { HOME_PATH } from 'navigation/routes';

interface IAccountAuthorizationsContext {
  authorizations: AccountAuthorizations;
}

export const AccountAuthorizationsContext = createContext<IAccountAuthorizationsContext>({
  authorizations: null,
});

export const AccountAuthorizationsProvider = ({ children }) => {
  const [authorizations, setAccountAuthorizationsRequest] =
    useDataFetcher<AccountAuthorizations>();
  const coreService = useCoreService();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (params && params.accountNumber) {
      const searchParams = new SearchAccountMovementsRequest({
        nroCuenta: params.accountNumber,
      });
      setAccountAuthorizationsRequest(() =>
        coreService.getAccountAuthorizations(searchParams).then((response) => {
          return response.body;
        }),
      );
    } else {
      navigate(HOME_PATH);
    }
  }, [navigate, params, setAccountAuthorizationsRequest, coreService]);

  const contextValue = useMemo(() => {
    return {
      authorizations: authorizations.data,
    };
  }, [authorizations.data]);
  return (
    <AccountAuthorizationsContext.Provider value={contextValue}>
      <LoadingSpinner isLoading={authorizations.isLoading}>{children}</LoadingSpinner>
    </AccountAuthorizationsContext.Provider>
  );
};
